import { Module } from 'vuex'
import { IUser } from '@/shared/model/user.model'

interface AccountState {
  logon: boolean;
  userIdentity: IUser | null;
  authenticated: boolean;
  ribbonOnProfiles: string;
  activeProfiles: string;
  error: string;
}

export const accountStore: Module<AccountState, any> = {
  state: {
    logon: false,
    userIdentity: null,
    authenticated: false,
    ribbonOnProfiles: '',
    activeProfiles: '',
    error: '',
  },
  getters: {
    logon: (state): boolean => state.logon,
    account: (state): IUser | {} => state.userIdentity || {},
    authenticated: (state): boolean => state.authenticated,
    activeProfiles: (state): string => state.activeProfiles,
    ribbonOnProfiles: (state): string => state.ribbonOnProfiles,
  },
  mutations: {
    authenticate (state) {
      state.logon = true
      state.error = ''
    },
    authenticated (state, identity) {
      state.userIdentity = identity
      state.authenticated = true
      state.logon = false
      state.error = ''
    },
    updateCurrentUserData (state, identity) {
      if (!state.authenticated || !state.userIdentity) {
        throw new Error('Cannot updateCurrentUserData. Login first')
      }
      state.userIdentity = identity
    },
    setActiveProfiles (state, profile) {
      state.activeProfiles = profile
    },
    setRibbonOnProfiles (state, ribbon) {
      state.ribbonOnProfiles = ribbon
    },
    authError (state, errorMessage) {
      console.log('MSG: authError -> errorMessage', errorMessage)
      state.error = errorMessage
    },
  },
}
